import { useLazyQuery } from '@apollo/client';
import { GetDriverContractPDFRequest, GetDriverContractPDFResponse, CITRIN_GET_DRIVER_CONTRACT_PDF } from '..';

export const useGetDriverContractQuery = () => {
    const [fetchPDF, { loading, error }] = useLazyQuery<GetDriverContractPDFResponse, GetDriverContractPDFRequest>(
        CITRIN_GET_DRIVER_CONTRACT_PDF
    );

    // Fonction unique pour charger + télécharger le PDF
    const loadAndDownloadPDF = async (driverId: string) => {
        try {
            const result = await fetchPDF({ variables: { driverId } });

            const pdfBase64 = result?.data?.CITRIN_MGT_generateDriverContractById?.pdfBase64;
            if (!pdfBase64) return;

            const pdfData = 'data:application/pdf;base64,' + pdfBase64;
            const link = document.createElement('a');
            link.href = pdfData;
            link.download = 'Contrat_CITRIN.pdf';
            link.click();
        } catch (err) {
            console.error('Erreur lors du téléchargement du PDF :', err);
        }
    };

    return {
        loadAndDownloadPDF, // fonction unique
        loading,
        error,
    };
};
